import { useEffect, useState } from 'react';

// The one responsive breakpoint the app's layout shell switches on (sidebar →
// off-canvas drawer + top bar). Keep it in sync with the `@media (max-width:
// 768px)` rules in styles/global.css / components/Sidebar.css — CSS custom
// properties can't be used inside @media, so it's a documented constant.
export const MOBILE_MAX_WIDTH = 768;

const QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

// True at phone/small-tablet widths. Only for the few things CSS alone can't
// express (which sidebar markup to render); prefer @media for everything else.
export default function useIsMobile() {
  const get = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY).matches : false);
  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange); // older Safari
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return isMobile;
}
